import { render } from "./AR.vue?vue&type=template&id=c7be05c6"
import script from "./AR.vue?vue&type=script&lang=js"
export * from "./AR.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__